import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../api/apiSlice";


export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getWasteCategoryuserApp: builder.query({
            query: () => `/b2g/eco-admin/user/waste-category`,
            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gWasteCategoryUserApp', id: 'List' }
            ]
        }),
        getUserapp: builder.query({
            query: () => `b2g/eco-admin/user/waste-category/unit`,
            transformResponse: responseData => {
                return responseData?.data;
            },
            providesTags: [
                { type: 'B2gUserApp', id: 'List' }
            ]
        }),
        addNewWasteCategoryuserapp: builder.mutation({
            query: body => ({
                url: '/b2g/eco-admin/user/waste-category',
                method: 'POST',
                body: body
            }),
            invalidatesTags: [
                { type: 'B2gWasteCategoryUserApp', id: 'List' }
            ]
        }),
        deleteWasteCategoryuserApp: builder.mutation({
            query: id => ({
                url: `/b2g/eco-admin/user/waste-category/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: [
                { type: 'B2gWasteCategoryUserApp', id: 'List' }
            ]
        }),
        editWasteCategoryUserApp: builder.mutation({
            query: payLoad => ({
                url: `/b2g/eco-admin/user/waste-category`,
                method: 'PATCH',
                body: payLoad
            }),
            invalidatesTags: [
                { type: 'B2gWasteCategoryUserApp', id: 'List' }
            ]
        }),

    })
})

export const {
    useGetWasteCategoryuserAppQuery,
    useGetUserappQuery,
    useAddNewWasteCategoryuserappMutation,
    useDeleteWasteCategoryuserAppMutation,
    useEditWasteCategoryUserAppMutation,

} = extendedApiSlice
